import { GAME_ID, TOGGLE_PARTICLES, SELECT_LEVEL } from '../../data/punchlineConstants';

const initialState = {
  particlesOn: false,
};

const punchlineNavigationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    case SELECT_LEVEL:
      return {
        particlesOn: false,
      };
    case TOGGLE_PARTICLES:
      return {
        particlesOn: !state.particlesOn,
      };
    default:
      return state;
  }
};

export default punchlineNavigationReducer;
